import { analyticsClient } from "sdks/analytics";
import { EventField } from "sdks/analytics/types";

export const logReferralsHomeImpression = (totalReferrals: number, activeFilter: string) => {
    analyticsClient.logImpression({
        [EventField.SN]: 'referrals',
        [EventField.ON]: 'Referrals list',
        [EventField.F1]: String(totalReferrals),
        [EventField.F2]: activeFilter,
    });
};

export const logDownloadButtonClick = () => {
    analyticsClient.logClick({
        [EventField.ON]: 'download button',
    });
};

export const logSearchButtonClick = (searchName?: string) => {
    analyticsClient.logClick({
        [EventField.ON]: 'search btn',
        ...(searchName && { [EventField.F1]: searchName }),
    });
};

export const logFilterClick = (selectedFilter: string) => {
    analyticsClient.logClick({
        [EventField.ON]: 'Filter',
        [EventField.F1]: selectedFilter,
    });
};

export const logReferralCardClick = (referralDetails: { referee_name: string; referee_status?: string; referral_id?: string }) => {
    analyticsClient.logClick({
        [EventField.ON]: 'referral_card',
        [EventField.OV]: 'referral_card_click',
        [EventField.F1]: referralDetails.referee_name,
        ...(referralDetails.referee_status && { [EventField.F2]: referralDetails.referee_status }),
        ...(referralDetails.referral_id && { [EventField.F3]: referralDetails.referral_id }),
    });
};

